import { render, staticRenderFns } from "./ScenicElements.vue?vue&type=template&id=4a022d52&scoped=true&"
import script from "./ScenicElements.vue?vue&type=script&lang=js&"
export * from "./ScenicElements.vue?vue&type=script&lang=js&"
import style0 from "./ScenicElements.vue?vue&type=style&index=0&id=4a022d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a022d52",
  null
  
)

export default component.exports